import './App.css';
import { useLayoutEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './components/Home.js'
import Powerball from './components/Powerball.js'
import TellMeMore from './components/DataPage'
import Cover from './components/cover.js'
import LuckyDrop from './components/LuckyDrop.js'
import { power, mega} from './componentData.js'

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path={"/powerball"} element={<Powerball select={power} />}></Route>
        <Route path={"/mega"} element={<Powerball select={mega}/>}></Route>
        <Route path={"/tellmemorepower"} element={<TellMeMore select={power}/>}></Route>
        <Route path={"/tellmemoremega"} element={<TellMeMore select={mega}/>}></Route>
        <Route path={"/drop"} element={<LuckyDrop />}></Route>
        <Route path={"/cover"} element={<Cover />}></Route>
      </Routes>
    </>
  );
}

export default App;
